module.exports = __webpack_public_path__ + "static/media/facebook.a8f5cee4.svg";